export interface GoogleTagManagerData {
  gtm_id: string;
  gtm_auth: string;
  gtm_preview: string;
  gtm_resource_path: string;
}
